<template>
	<div
		class="menu-mobile-open"
		:class="{
			'd-flex': menu.mobile_menu_open,
			'd-none': !menu.mobile_menu_open,
		}">
		<div class="sidebar-open">
			<div
				class="d-flex px-8 justify-content-between align-items-center"
				style="height: 65px; background-color: #1a1a27">
				<a href="#" class="img-menu-open">
					<img alt="Logo" :src="logo" class="h-45px logo" />
				</a>
				<div
					class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle"
					@click="menu.mobileMenuOpenClose()">
					<span class="svg-icon svg-icon-1">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none">
							<path
								d="M14.6 4L6.6 12L14.6 20H10.6L3.3 12.7C2.9 12.3 2.9 11.7 3.3 11.3L10.6 4H14.6Z"
								fill="black"></path>
							<path
								opacity="0.3"
								d="M21.6 4L13.6 12L21.6 20H17.6L10.3 12.7C9.9 12.3 9.9 11.7 10.3 11.3L17.6 4H21.6Z"
								fill="black"></path>
						</svg>
					</span>
				</div>
			</div>
			<div v-for="(item, index) in side_menu_items" :key="index">
				<sidebar_menu_item
					:item="item"
					:side_bar_menu_open="menu.mobile_menu_open" />
			</div>
		</div>
		<div
			class="opacity-menu-open"
			@click="menu.mobileMenuOpenClose()"></div>
	</div>
</template>

<script setup lang="ts">
	import { menuStore } from '../../stores/menu';
	import { usePage } from '@inertiajs/vue3';
	import sidebar_menu_item from '../../components/menus/sidebar_menu_item.vue';
	import { computed } from '@vue/reactivity';

	const menu = menuStore();
	const side_menu_items = computed(() => menuStore().side_menu_items);

	const logo = usePage().props?.logo_img_path as string;
</script>

<style scoped>
	.opacity-menu-open {
		height: 100vh;
		width: 40%;
		background-color: black;
		opacity: 0.5;
	}
	.menu-mobile-open {
		height: 100vh;
		width: 100%;
		position: fixed;
		z-index: 999;
		overflow-y: visible;
	}
	.sidebar-open {
		background-color: #1e1e2d;
		height: 100vh;
		width: 60%;
		transition: all 0.3s ease;
		margin-top: 0px;
	}

	.img-menu-open {
		display: block;
	}
</style>
